<template>
  <ExGenericSelector
    v-model="isMenuOpen"
    :width="width"
    :tipSide="tipSide"
    :scrollContainerClass="scrollContainerClass"
    :attachSelector="attachSelector"
    :absolute="absolute"
    :hideOnScrollClasses="hideOnScrollClasses"
    :translateXOffset="translateXOffset"
    :translateYOffset="translateYOffset"
    @displayTop="displayTop = $event"
    :showImportanceSelector="true"
    :typeText="'Importance'"
    :hideTip="hideTip"
  >
    <template #activator>
      <EXTooltip v-if="showTooltip" title="Line Menu" placement="top" :delay="100">
        <div class="employee_availability_icon-menu-icon" v-if="hasSlot('activator')">
          <slot name="activator"></slot>
        </div>
        <div
          v-else
          class="employee_availability_icon-menu-icon ex-menu-icon"
          :class="{
            'ex-menu-icon-hori': !vertical,
          }"
        >
          <svg
            v-if="!vertical"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="4"
            viewBox="0 0 18 4"
            fill="none"
          >
            <path
              d="M9 3C9.55228 3 10 2.55228 10 2C10 1.44772 9.55228 1 9 1C8.44772 1 8 1.44772 8 2C8 2.55228 8.44772 3 9 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 3C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="18"
            viewBox="0 0 4 18"
            fill="none"
          >
            <path
              d="M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </EXTooltip>
      <div v-else>
        <div class="employee_availability_icon-menu-icon" v-if="hasSlot('activator')">
          <slot name="activator"></slot>
        </div>
        <div
          v-else
          class="employee_availability_icon-menu-icon ex-menu-icon"
          :class="{
            'ex-menu-icon-hori': !vertical,
          }"
        >
          <svg
            v-if="!vertical"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="4"
            viewBox="0 0 18 4"
            fill="none"
          >
            <path
              d="M9 3C9.55228 3 10 2.55228 10 2C10 1.44772 9.55228 1 9 1C8.44772 1 8 1.44772 8 2C8 2.55228 8.44772 3 9 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 3C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="18"
            viewBox="0 0 4 18"
            fill="none"
          >
            <path
              d="M2 10C2.55228 10 3 9.55228 3 9C3 8.44772 2.55228 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 3C2.55228 3 3 2.55228 3 2C3 1.44772 2.55228 1 2 1C1.44772 1 1 1.44772 1 2C1 2.55228 1.44772 3 2 3Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 17C2.55228 17 3 16.5523 3 16C3 15.4477 2.55228 15 2 15C1.44772 15 1 15.4477 1 16C1 16.5523 1.44772 17 2 17Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </template>
    <template #content>
      <ul
        class="dropdown-menu ex_dropdownmenu pl-0"
        :class="[contentClass, { displayTop: displayTop }]"
      >
        <li
          v-for="(item, index) in dropdownItems"
          :key="index"
          :class="{
            disabled: item.disabled,
            'has-disabled-tip': item.disabled && item.disabledTooltip,
            negative: item.negative,
            'menu-separator': item.separator,
          }"
          @click="!item.separator && !item.disabled && onClick(item)"
        >
          <div v-if="item.separator" class="menu-separator-line"></div>
          <div
            v-else-if="item.disabled && item.disabledTooltip"
            class="ex-menu-dropdown-disabled-row"
          >
            <EXTooltip :title="item.disabledTooltip" placement="top" :delay="100">
              <div class="item-content">
                <span :class="{ destructive_text: item.destructive }">{{ item.name }}</span>
                <img
                  v-if="item.icon"
                  :src="getIconSrc(item.icon)"
                  alt="icon"
                  class="dropdown-image"
                  @error="handleImageError"
                />
              </div>
            </EXTooltip>
          </div>
          <div v-else class="item-content">
            <span :class="{ destructive_text: item.destructive }">{{ item.name }}</span>
            <img
              v-if="item.icon"
              :src="getIconSrc(item.icon)"
              alt="icon"
              class="dropdown-image"
              @error="handleImageError"
            />
          </div>
        </li>
      </ul>
    </template>
  </ExGenericSelector>
</template>
<script setup>
import { ref, watch, useSlots } from "vue";
import ExGenericSelector from "@components/DropDownMenu/ExGenericSelector.vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";
import cancelInviteIcon from "@components/assets/icons/dropdown/cancel-invite.svg";

const props = defineProps({
  dropdownItems: {
    type: Array,
    default: () => [],
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 195,
  },
  tipSide: {
    type: String,
    default: "right",
  },
  scrollContainerClass: {
    type: String,
    default: ".ex-main-container",
  },
  attachSelector: {
    type: String,
    default: "body",
  },
  absolute: {
    type: Boolean,
    default: false,
  },
  hideOnScrollClasses: {
    type: Array,
    default: null,
  },
  translateXOffset: {
    type: Number,
    default: 0,
  },
  translateYOffset: {
    type: Number,
    default: 0,
  },
  vertical: {
    type: Boolean,
    default: false,
  },
  showTooltip: {
    type: Boolean,
    default: false,
  },
  hideTip: {
    type: Boolean,
    default: false,
  },
  // Optional extra class applied to the dropdown <ul>. Lets a consumer namespace
  // per-instance style overrides without affecting other MenuIcon usages (the
  // dropdown is teleported to <body>, so this is the only reliable style hook).
  contentClass: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["onClick"]);

const isMenuOpen = ref(props.isOpen);
const displayTop = ref(false);

watch(
  () => props.isOpen,
  (newVal) => {
    isMenuOpen.value = newVal;
  }
);

const onClick = (item) => {
  if (item?.disabled) return;
  emit("onClick", item);
  isMenuOpen.value = false;
};

const getIconSrc = (icon) => {
  if (!icon) return "";
  if (typeof icon === "object" && icon !== null && icon.default) return icon.default;
  if (typeof icon !== "string") return icon;
  if (icon === "icons/dropdown/cancel-invite.svg") {
    return typeof cancelInviteIcon === "string"
      ? cancelInviteIcon
      : cancelInviteIcon?.default || "";
  }
  if (icon.startsWith("/") || icon.startsWith("http") || icon.startsWith("data:")) return icon;
  try {
    return require("@components/assets/" + icon);
  } catch (error) {
    console.warn(`Failed to load icon: ${icon}`, error);
    return "";
  }
};

const handleImageError = (event) => {
  console.warn("Image failed to load:", event.target.src);
  // Optionally hide the image element on error
  event.target.style.display = "none";
};

const slots = useSlots();
const hasSlot = (name) => {
  return !!slots[name];
};
</script>
<style>
.employee_availability_icon-menu-icon {
  position: relative;
  content: "";
  display: flex;
  justify-content: center;
  align-items: center;
}
.ex_dropdownmenu {
  box-shadow: none !important;
}
.dropdown-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu li {
  cursor: pointer;
  height: 40px;
  width: 100%;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  color: #26282c;
  border-bottom: 1px solid #dee0e3;
  display: flex;
  align-items: center;
}
.dropdown-menu li:last-child {
  border-bottom: none;
}
.dropdown-menu li.negative {
  color: #d80027;
}
.dropdown-menu li.negative:hover img {
  filter: brightness(0) saturate(100%) invert(21%) sepia(78%) saturate(5666%) hue-rotate(337deg)
    brightness(77%) contrast(127%);
}
.dropdown-menu li:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dropdown-menu li:last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.dropdown-menu li.menu-separator {
  cursor: default;
  min-height: 0;
  height: auto;
  padding: 0;
  border-bottom: none;
}
.dropdown-menu li.menu-separator .menu-separator-line {
  height: 0;
  margin: 4px 0;
}
.dropdown-menu li.menu-separator:hover {
  background-color: transparent;
}
.dropdown-menu li.negative:hover {
  background-color: #fef3f3;
}
.dropdown-menu li:hover {
  background-color: #dee0e3;
}

.dropdown-menu.show {
  display: block;
}
.ex_dropdownmenu .item-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 31px;
}
.ex_dropdownmenu .item-content span {
  white-space: nowrap !important;
}
.ex_dropdownmenu .item-content span.destructive_text {
  color: #d80027;
}
ul.ex_dropdownmenu > li.disabled:not(.has-disabled-tip):not(.has-disabled-reason) {
  opacity: 0.5;
  pointer-events: none;
  background-color: #ffffff;
}
ul.ex_dropdownmenu > li.disabled.has-disabled-tip {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #ffffff;
}
ul.ex_dropdownmenu > li.disabled.has-disabled-tip:hover {
  background-color: #ffffff !important;
}
/* Full row width + text/icon spacing: override global .el-tooltip { width: fit-content } */
ul.ex_dropdownmenu > li.has-disabled-tip {
  padding: 0;
}
ul.ex_dropdownmenu > li.has-disabled-tip > .ex-menu-dropdown-disabled-row {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
}
ul.ex_dropdownmenu > li.has-disabled-tip .el-tooltip {
  width: 100% !important;
  max-width: 100% !important;
  display: block !important;
}
ul.ex_dropdownmenu > li.has-disabled-tip ._parent-content {
  display: block;
  width: 100%;
}
ul.ex_dropdownmenu > li.has-disabled-tip .item-content {
  width: 100%;
  box-sizing: border-box;
}
.employee_availability_icon-menu-icon {
  background-color: transparent !important;
}
.ex-menu-icon {
  padding: 12px 20px;
  text-align: center;
  margin: 5px;
  width: fit-content;
  cursor: url("../assets/cursorArrow.svg"), auto;
}
.ex-menu-icon:hover {
  background-color: #f2edff !important;
  padding: 12px 20px;
  text-align: center;
  margin: 5px;
  box-shadow: 0px 4px 4px 0px #0000000f;
  border-radius: 8px;
}
.ex-menu-icon-hori {
  padding: 20px 12px !important;
}
.ex-menu-icon-hori:hover {
  padding: 20px 12px !important;
}
</style>
